import { useEffect } from 'react';

export const ErrorFallback = ({ error, componentStack }) => {
  useEffect(() => {
    // Redirect immediately; Sentry is expected to have logged the error
    if (!window.location.href.includes('localhost')) {
      console.log('caught a rendering error sentry')
      // window.top.location.replace('https://www.hannamfertility.com/booking-call-clinic');
    }
  }, []);

  return null;
};
